// extracted by mini-css-extract-plugin
export default {"confirmButton":"_629953e5947237ca","disabledConfirmButton":"febcea0165f6889e"};